import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import { Button, Switcher } from '@whitbread-eos/atoms';
import { renderSanitizedHtml, formatDataTestId } from '@whitbread-eos/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ManageCookies(_ref) {
  var labels = _ref.labels,
    cookiePermissions = _ref.cookiePermissions,
    setCookiePermissions = _ref.setCookiePermissions,
    setCookiePolicies = _ref.setCookiePolicies,
    modalStyles = _ref.modalStyles;
  var manageCookiesLabels = labels === null || labels === void 0 ? void 0 : labels.cookieConsent.cookiePolicies.manageView;
  var setCookiePermissionValue = (cookieName, status) => {
    var newCookiePermissions = cookiePermissions === null || cookiePermissions === void 0 ? void 0 : cookiePermissions.map(cookiePermission => {
      if (cookiePermission.name === cookieName) {
        return _objectSpread(_objectSpread({}, cookiePermission), {}, {
          value: status
        });
      }
      return cookiePermission;
    });
    if (setCookiePermissions) {
      setCookiePermissions(newCookiePermissions);
    }
  };
  return _jsxs(Box, _objectSpread(_objectSpread(_objectSpread({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.wrapperStyles), manageContainerStyle), {}, {
    "data-testid": "ManageCookieModal-Container",
    children: [_jsx(Box, _objectSpread(_objectSpread({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.textStyles.description), {}, {
      "data-testid": "ManageCookieModal-Description",
      children: renderSanitizedHtml(manageCookiesLabels === null || manageCookiesLabels === void 0 ? void 0 : manageCookiesLabels.description)
    })), _jsx(Divider, _objectSpread(_objectSpread({}, dividerStyle), {}, {
      "data-testid": "ManageCookieModal-Divider"
    })), _jsx(Flex, {
      flexDirection: "column",
      "data-testid": "ManageCookieModal-CookieGroup",
      children: manageCookiesLabels === null || manageCookiesLabels === void 0 ? void 0 : manageCookiesLabels.cookieGroup.map(cookie => {
        return _jsxs(Flex, {
          flexDirection: "column",
          "data-testid": formatDataTestId('ManageCookieModal', cookie === null || cookie === void 0 ? void 0 : cookie.cookieName),
          mb: "lg",
          children: [_jsxs(Flex, _objectSpread(_objectSpread({
            flexDirection: "row"
          }, cookieGroupTitleStyle.container), {}, {
            children: [_jsx(Text, _objectSpread(_objectSpread({
              "data-testid": formatDataTestId('ManageCookieModal', cookie === null || cookie === void 0 ? void 0 : cookie.title)
            }, cookieGroupTitleStyle.text), {}, {
              children: cookie.title
            })), cookie.cookieName === 'permissionEssential' ? _jsxs(Text, _objectSpread(_objectSpread({}, alwaysActiveStyle), {}, {
              "data-testid": "ManageCookieModal-".concat(cookie.cookieName, "-Text"),
              children: [manageCookiesLabels.alwaysActiveText, ' ']
            })) : _jsx(Switcher, {
              size: "lg",
              isChecked: cookie.isAlwaysActive,
              onChange: status => setCookiePermissionValue(cookie.cookieName, status.isChecked),
              "data-testid": "ManageCookieModal-".concat(cookie.cookieName, "-Switcher")
            })]
          })), _jsx(Box, _objectSpread(_objectSpread({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.textStyles.description), {}, {
            "data-testid": formatDataTestId('ManageCookieModal', "".concat(cookie === null || cookie === void 0 ? void 0 : cookie.title, "-Description")),
            children: renderSanitizedHtml(cookie === null || cookie === void 0 ? void 0 : cookie.description)
          }))]
        }, cookie.cookieName);
      })
    }), _jsx(Flex, _objectSpread(_objectSpread(_objectSpread({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.buttonsStyle), confirmBtnStyle), {}, {
      children: _jsx(Button, {
        size: "full",
        mb: "lg",
        variant: "primary",
        "data-testid": formatDataTestId('ManageCookieModal', manageCookiesLabels === null || manageCookiesLabels === void 0 ? void 0 : manageCookiesLabels.saveSettingsButtonText),
        onClick: () => setCookiePolicies(),
        children: manageCookiesLabels === null || manageCookiesLabels === void 0 ? void 0 : manageCookiesLabels.saveSettingsButtonText
      })
    }))]
  }));
}
var manageContainerStyle = {
  display: 'block',
  height: {
    sm: '35rem',
    md: '40rem',
    lg: '45rem'
  },
  width: {
    sm: '30.75rem',
    lg: '30.75rem'
  }
};
var dividerStyle = {
  mt: 'lg',
  mb: 'lg'
};
var cookieGroupTitleStyle = {
  container: {
    justifyContent: 'space-between',
    mb: 'md'
  },
  text: {
    color: 'darkGrey1',
    fontWeight: 'semibold',
    fontSize: '2xl',
    lineHeight: '4'
  }
};
var alwaysActiveStyle = {
  fontWeight: 'medium',
  fontSize: 'xl',
  lineHeight: '3'
};
var confirmBtnStyle = {
  width: 'full'
};